module.exports = __webpack_public_path__ + "static/media/friday-the-13th.157b593e.svg";